import { httpRequest } from "../http";

export type ReportingNetworkConfig = {
  id: number;
  key: string;
  label: string;
  // Null for a direct delivery channel. Mail is not a publisher network and never
  // enters that enum, so anything switching on this must handle null.
  publisher_network: string | null;
  icon: string;
  color: string;
  bg_color: string;
  sort_order: number;
  is_active: boolean;
};

export async function fetchReportingNetworkConfigs(): Promise<
  ReportingNetworkConfig[]
> {
  return httpRequest<ReportingNetworkConfig[]>(
    `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/reference_data/reporting_network_configs/`,
    { method: "GET" },
  );
}
